module finadai.app.negotiations.paid {
    export var NAME = 'finadai.negotiations.paid';
    function NegotiationsPaidController($scope, notify, negotiationsService: services.NegotiationsService, agents, $filter) {
        $scope.agents = agents.data.data;
        $scope.filters = { with: 'credits,credits.loan_type,customer,agent,meta,payment_type', 'only_paid': 1};
        $scope.noteStatus = [
            {
                "id": 0,
                "name": "Pendiente",

            },
            {
                "id": 1,
                "name": "Entregado",
            }
        ];

        $scope.query = {
            order: '-created_at._date',
            limit: 10,
            page: 1
        };
        $scope.reload = () => {
            $scope.promise = negotiationsService.get(null, angular.copy($scope.filters)).then(response => {
                $scope.negotiations = response.data;
                return response;
            });
        }
        $scope.download = () => {
            negotiationsService.download($scope.filters).then(response => {
                if(response.status == 200){
                   // window.location = response.data.url;
                }
            });
        }
        $scope.changeNoteStatus = (negotiation) => {
            if(negotiation.note_status != negotiation.new_note_status) {
                negotiationsService.changeNoteStatus({negotiation_id: negotiation.id, note_status: negotiation.new_note_status}).then(response => {
                    notify('Estado de Pagare Actualizado.');
                })
            }
        }
        $scope.$watchCollection('filters', function (newNames, oldNames) {
            $scope.reload();
        });
    }
    export function run() {
        var list = angular.module(NAME, []);
        list.controller('NegotiationsPaidController', NegotiationsPaidController);
    }
} finadai.app.negotiations.paid.run();